"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function KafkaZero() {
    return {
        eventContent: '',
        eventContext: '',
        eventElementName: '',
        eventElementType: '',
        eventFormDesign: '',
        eventFormName: '',
        eventFormVendor: '',
        eventFormVersion: '',
        eventStep: 0,
        eventStepType: '',
        eventFieldNumber: 0,
        eventType: '',
        eventValue: '',
        eventTimestamp: 0,
        eventSession: '',
    };
}
exports.default = KafkaZero;
